import * as React from 'react'
import { useEffect } from 'react'
import { FlapComponent, lastQuestionStyles, sidebarStyles } from './styles'
import { Accordion, AccordionDetails, AccordionSummary, Box, Button } from '@mui/material'
import { questions } from '../../docs/sidebar-help-section'

type SideBarHelperProps = {
	onChange: (state: boolean) => void
	show: boolean
	accordionDefaultOpen: string | false
}

export default function SidebarHelper({ onChange, show, accordionDefaultOpen }: SideBarHelperProps) {
	const [open, setOpen] = React.useState(show)
	const [expanded, setExpanded] = React.useState<string | false>(accordionDefaultOpen)

	useEffect(() => onChange(open), [onChange, open])

	useEffect(() => setOpen(show), [show])

	const handleChange = (panel: string) => (_event: React.SyntheticEvent, isExpanded: boolean) => {
		setExpanded(isExpanded ? panel : false)
	}

	return (
		<React.Fragment>
			<Box display="flex" flexDirection="column" sx={sidebarStyles(open)}>
				<Button variant="outlined" onClick={() => setOpen(false)}>
					Close
				</Button>
				<Box sx={{ marginTop: '20px' }}>
					{questions.map(
						(question: { title: string; answer: string; enabled: boolean }, index: number) =>
							question.enabled && (
								<Accordion
									expanded={expanded === `answer_${index}`}
									variant="elevation"
									onChange={handleChange(`answer_${index}`)}
									sx={lastQuestionStyles(index === questions.length - 1)}
								>
									<AccordionSummary
										aria-controls="panel1-content"
										id="panel1-header"
										sx={{ fontSize: '14px' }}
									>
										<div
											dangerouslySetInnerHTML={{ __html: question.title }}
											style={{ fontWeight: 'bold' }}
										/>
									</AccordionSummary>
									<AccordionDetails sx={{ fontSize: '14px' }}>
										<div dangerouslySetInnerHTML={{ __html: question.answer }} />
									</AccordionDetails>
								</Accordion>
							),
					)}
				</Box>
			</Box>

			{/*<FlapComponent onClick={() => setOpen(true)} style={{ display: open ? 'none' : 'block' }}>*/}
			{/*	<p>Help</p>*/}
			{/*</FlapComponent>*/}
		</React.Fragment>
	)
}
